import React, { useEffect, useState } from "react";
import { register } from "../serviceWorkerRegistration";

const INSTALL_DISMISSED_KEY =
  "fleet_pwa_install_dismissed";

const INSTALLED_KEY =
  "fleet_pwa_installed";

const PWAUpdate = () => {

  const [installPrompt, setInstallPrompt] =
    useState(null);

  const [showInstall, setShowInstall] =
    useState(false);

  const [showUpdate, setShowUpdate] =
    useState(false);

  const [registration, setRegistration] =
    useState(null);

  useEffect(() => {

    register({
      onUpdate: (reg) => {

        console.log(
          "[PWA] Update available"
        );

        setRegistration(reg);
        setShowUpdate(true);
      },

      onSuccess: () => {

        console.log(
          "[PWA] Service worker installed"
        );
      }
    });

  }, []);


  useEffect(() => {

    const handleBeforeInstallPrompt = (event) => {

      console.log(
        "[PWA] Install prompt available"
      );

      event.preventDefault();

      if (
        localStorage.getItem(INSTALLED_KEY) === "true"
      ) {
        return;
      }

      if (
        localStorage.getItem(
          INSTALL_DISMISSED_KEY
        ) === "true"
      ) {
        return;
      }

      setInstallPrompt(event);
      setShowInstall(true);
    };


    window.addEventListener(
      "beforeinstallprompt",
      handleBeforeInstallPrompt
    );

    const handleInstalled = () => {

      console.log(
        "[PWA] Application installed"
      );

      localStorage.setItem(
        INSTALLED_KEY,
        "true"
      );

      setInstallPrompt(null);
      setShowInstall(false);
    };


    window.addEventListener(
      "appinstalled",
      handleInstalled
    );


    return () => {

      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );

      window.removeEventListener(
        "appinstalled",
        handleInstalled
      );

    };

  }, []);


  const handleInstall = async () => {

    if (!installPrompt) {
      return;
    }

    try {

      installPrompt.prompt();

      const result =
        await installPrompt.userChoice;

      console.log(
        "[PWA] Install result:",
        result.outcome
      );

      if (result.outcome === "accepted") {

        localStorage.setItem(
          INSTALLED_KEY,
          "true"
        );

        setShowInstall(false);

      } else {


        localStorage.setItem(
          INSTALL_DISMISSED_KEY,
          "true"
        );

        setShowInstall(false);
      }

      setInstallPrompt(null);

    } catch (error) {

      console.error(
        "[PWA] Install failed:",
        error
      );

    }
  };



  const handleCloseInstall = () => {

    localStorage.setItem(
      INSTALL_DISMISSED_KEY,
      "true"
    );

    setShowInstall(false);
  };



  const handleUpdate = () => {

    if (!registration) {
      window.location.reload();
      return;
    }

    const waitingWorker =
      registration.waiting;

    if (!waitingWorker) {
      window.location.reload();
      return;
    }

    waitingWorker.postMessage({
      type: "SKIP_WAITING"
    });

    navigator.serviceWorker.addEventListener(
      "controllerchange",
      () => {
        window.location.reload();
      },
      { once: true }
    );
  };


  if (!showInstall && !showUpdate) {
    return null;
  }


  return (
    <>
      {/* INSTALL */}

      {showInstall && (
        <div style={styles.overlay}>

          <div style={styles.popup}>

            <div style={styles.icon}>
              🚐
            </div>

            <h3 style={styles.title}>
              Install Srinivasa Fleet
            </h3>

            <p style={styles.text}>
              Install Srinivasa Fleet Management Pro
              on your phone for quick access.
            </p>

            <button
              type="button"
              onClick={handleInstall}
              style={styles.primaryButton}
            >
              Install App
            </button>

            <button
              type="button"
              onClick={handleCloseInstall}
              style={styles.secondaryButton}
            >
              Not Now
            </button>

          </div>

        </div>
      )}


      {/* UPDATE */}

      {showUpdate && (
        <div style={styles.overlay}>

          <div style={styles.popup}>

            <div style={styles.icon}>
              🔄
            </div>

            <h3 style={styles.title}>
              New Version Available
            </h3>

            <p style={styles.text}>
              A new version of Srinivasa Fleet
              Management Pro is available.
            </p>

            <button
              type="button"
              onClick={handleUpdate}
              style={styles.primaryButton}
            >
              Update Now
            </button>

          </div>

        </div>
      )}
    </>
  );
};


const styles = {

  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 999999,
    background: "rgba(0, 0, 0, 0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px"
  },

  popup: {
    width: "100%",
    maxWidth: "380px",
    background: "#ffffff",
    borderRadius: "18px",
    padding: "25px",
    textAlign: "center",
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)"
  },

  icon: {
    width: "58px",
    height: "58px",
    margin: "0 auto 14px",
    borderRadius: "16px",
    background: "#0F1A38",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "28px"
  },

  title: {
    margin: "0 0 10px",
    fontSize: "20px",
    fontWeight: 700,
    color: "#111827"
  },

  text: {
    margin: "0 0 20px",
    fontSize: "14px",
    lineHeight: 1.5,
    color: "#6b7280"
  },

  primaryButton: {
    width: "100%",
    border: "none",
    borderRadius: "10px",
    padding: "12px 16px",
    background: "#0F1A38",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    marginBottom: "8px"
  },

  secondaryButton: {
    width: "100%",
    border: "none",
    background: "transparent",
    padding: "10px",
    color: "#6b7280",
    fontSize: "14px",
    cursor: "pointer"
  }

};


export default PWAUpdate;